import React from 'react';
import JobDetail from '../../../../Components/Job/JobDetail';
import Permission from '../../../../permissions';
import Container from '../../../Container';
import PrivatePage from '../PrivatePage';

const JobDetailPage = ({ match, history }) => (
    <PrivatePage requiredUserPermission={Permission.ReadJobs}>
        <Container>
            <JobDetail history={history} jobId={match.params.id} />
        </Container>
    </PrivatePage>
);

export default JobDetailPage;
